module.exports = __webpack_public_path__ + "img/warning.51233ec2.svg";